// "A new version is ready": shows when the service worker has a newer build waiting. Tapping swaps it in.
// Also says once when the app is ready to work with no signal.
import { useEffect, useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@/ui/Button";
import styles from "./UpdateBanner.module.css";

export function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({ onRegisterError: (e: unknown) => console.warn("Service worker failed to register", e) });
  return <UpdateBannerView needRefresh={needRefresh} offlineReady={offlineReady} onRefresh={() => void updateServiceWorker(true)} onDismissOffline={() => setOfflineReady(false)} />;
}

export function UpdateBannerView({ needRefresh, offlineReady, onRefresh, onDismissOffline }: { needRefresh: boolean; offlineReady: boolean; onRefresh: () => void; onDismissOffline: () => void }) {
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!offlineReady) return;
    const t = setTimeout(onDismissOffline, 5000);
    return () => clearTimeout(t);
  }, [offlineReady, onDismissOffline]);

  if (needRefresh) {
    return (
      <div className={styles.banner} role="status">
        <span>A new version of Stockroom is ready.</span>
        <Button tone="primary" disabled={busy} onClick={() => { setBusy(true); onRefresh(); }}>
          {busy ? "Refreshing…" : "Tap to refresh"}
        </Button>
      </div>
    );
  }
  if (offlineReady) {
    return (
      <div className={styles.banner} role="status">
        <span>Ready to work with no signal.</span>
        <Button onClick={onDismissOffline}>OK</Button>
      </div>
    );
  }
  return null;
}
